import { Backdrop, CircularProgress, useTheme } from "@mui/material";
import { useRecoilState } from "recoil";
import { LOADING } from "../service/SalesMarketingRecoil";

const Loader = () => {
    const [loading, setLoading] = useRecoilState(LOADING);
  
    return (
        <Backdrop open={loading} sx={{ zIndex: useTheme().zIndex.drawer + 1000}}>
            <CircularProgress size={94} />
        </Backdrop>
    );
}

export default Loader;